import {ErrorHandler, Injectable} from '@angular/core';
import {LoggerService} from '../original-services/logger.service';

@Injectable({ providedIn: 'root' })
export class GlobalErrorHandler extends ErrorHandler {
    constructor(private logger: LoggerService) {
        super();
    }

    handleError(error) {
        this.logger.error(`Error in app: ${error}`)
    }
}
